export const MA_MARKETPLACE_LOADER = {
  desktop: `
<div class="cui-grid cui-container -spacing--top-48 -spacing--bottom-120">
  <div class="cui-skeleton-heading -size--large -spacing--bottom-64 -resolution--desktop">
    <div class="cui-skeleton__item cui-skeleton-input__label -spacing--bottom-64" style="width: 405px;">
    </div>
    <div class="cui-skeleton-heading__content -spacing--top-4" style="display: inline-grid; width: max(300px, 100%);">
        <div class="cui-skeleton__item cui-skeleton-heading__title"></div>
        <div class="cui-skeleton__item cui-skeleton__description" style="width: 733px;"></div>
    </div>
  </div>
  <div class="cui cui-grid cui-container -gap--v-32">
    <div class="cui-row">
      <div class="cui-col-lg-12">
        <div class="cui-skeleton-rectangle -is--block -spacing--bottom-24" style="display: flex;">
          <div class="cui-skeleton__item" style="height: 241px; margin-right: 30px;"></div>
          <div class="cui-skeleton__item" style="height: 241px; margin-right: 30px;"></div>
          <div class="cui-skeleton__item" style="height: 241px;"></div>
        </div>
      </div>
      <div class="cui-col-lg-12">
        <div class="cui-skeleton-rectangle -is--block -spacing--bottom-24" style="display: flex;">
          <div class="cui-skeleton__item" style="height: 241px; margin-right: 30px;"></div>
          <div class="cui-skeleton__item" style="height: 241px; margin-right: 30px;"></div>
          <div class="cui-skeleton__item" style="height: 241px;"></div>
        </div>
      </div>
      <div class="cui-col-lg-12">
        <div class="cui-skeleton-rectangle -is--block -spacing--bottom-24" style="display: flex;">
          <div class="cui-skeleton__item" style="height: 241px; margin-right: 30px;"></div>
          <div class="cui-skeleton__item" style="height: 241px; margin-right: 30px;"></div>
          <div class="cui-skeleton__item" style="height: 241px;"></div>
        </div>
      </div>
      <div class="cui-col-lg-12">
        <div class="cui-skeleton-rectangle -is--block -spacing--bottom-64" style="display: flex;">
          <div class="cui-skeleton__item" style="height: 241px; margin-right: 30px;"></div>
          <div class="cui-skeleton__item" style="height: 241px; margin-right: 30px;"></div>
          <div class="cui-skeleton__item" style="height: 241px;"></div>
        </div>
      </div>
    </div>
    
    <div class="cui-row">
      <div class="cui-col-lg-12">
        <div class="cui-skeleton-rectangle -is--block">
          <div class="cui-skeleton__item" style="height: 400px;"></div>
        </div>
      </div>
    </div>
  </div>
</div>
<div class="cui-skeleton-rectangle -is--block">
  <div class="cui-skeleton__item" style="width: 100%; height: 128px;"></div>
</div>`,
  mobile: `
<div class="cui-grid cui-container -spacing--top-24 -spacing--bottom-64">
  <div class="cui-skeleton-heading -size--large -spacing--bottom-24 -resolution--mobile">
    <div class="cui-skeleton-heading__content" style="width: max(200px, 100%);">
      <div class="cui-skeleton__item cui-skeleton-heading__title"></div>
      <div class="cui-skeleton__item cui-skeleton__description"></div>
    </div>
  </div>
  
  <div class="cui cui-grid cui-container -gap--v-24">
    <div class="cui-row">
      <div class="cui-col-lg-12">
        <div class="cui-skeleton-rectangle -is--block" style="display: contents;">
          <div class="cui-skeleton__item" style="height: 247px; max(345px, 100%);"></div>
        </div>
      </div>
    </div>
    <div class="cui-row">
      <div class="cui-col-lg-12">
        <div class="cui-skeleton-rectangle -is--block" style="display: contents;">
          <div class="cui-skeleton__item" style="height: 247px; max(345px, 100%);"></div>
        </div>
      </div>
    </div>
    <div class="cui-row">
      <div class="cui-col-lg-12">
        <div class="cui-skeleton-rectangle -is--block" style="display: contents;">
          <div class="cui-skeleton__item" style="height: 247px; max(345px, 100%);"></div>
        </div>
      </div>
    </div>
    <div class="cui-row">
      <div class="cui-col-lg-12">
        <div class="cui-skeleton-rectangle -is--block" style="display: contents;">
          <div class="cui-skeleton__item" style="height: 247px; max(345px, 100%);"></div>
        </div>
      </div>
    </div>
    <div class="cui-row">
      <div class="cui-col-lg-12">
        <div class="cui-skeleton-rectangle -is--block" style="display: contents;">
          <div class="cui-skeleton__item" style="height: 247px; max(345px, 100%);"></div>
        </div>
      </div>
    </div>
    <div class="cui-row">
      <div class="cui-col-lg-12">
        <div class="cui-skeleton-rectangle -is--block" style="display: contents;">
          <div class="cui-skeleton__item" style="height: 247px; max(345px, 100%);"></div>
        </div>
      </div>
    </div>
    <div class="cui-row">
      <div class="cui-col-lg-12">
        <div class="cui-skeleton-rectangle -is--block" style="display: contents;">
          <div class="cui-skeleton__item" style="height: 247px; max(345px, 100%);"></div>
        </div>
      </div>
    </div>
    <div class="cui-row">
      <div class="cui-col-lg-12">
        <div class="cui-skeleton-rectangle -is--block" style="display: contents;">
          <div class="cui-skeleton__item" style="height: 247px; max(345px, 100%);"></div>
        </div>
      </div>
    </div>
    <div class="cui-row">
      <div class="cui-col-lg-12">
        <div class="cui-skeleton-rectangle -is--block" style="display: contents;">
          <div class="cui-skeleton__item" style="height: 247px; max(345px, 100%);"></div>
        </div>
      </div>
    </div>
    <div class="cui-row">
      <div class="cui-col-lg-12">
        <div class="cui-skeleton-rectangle -is--block" style="display: contents;">
          <div class="cui-skeleton__item" style="height: 247px; max(345px, 100%);"></div>
        </div>
      </div>
    </div>
    <div class="cui-row">
      <div class="cui-col-lg-12">
        <div class="cui-skeleton-rectangle -is--block" style="display: contents;">
          <div class="cui-skeleton__item" style="height: 247px; max(345px, 100%);"></div>
        </div>
      </div>
    </div>
    <div class="cui-row">
      <div class="cui-col-lg-12">
        <div class="cui-skeleton-rectangle -is--block" style="display: contents;">
          <div class="cui-skeleton__item" style="height: 247px; max(345px, 100%);"></div>
        </div>
      </div>
    </div>
    <div class="cui-row">
      <div class="cui-col-lg-12">
        <div class="cui-skeleton-rectangle -is--block" style="display: contents;">
          <div class="cui-skeleton__item" style="height: 400px; max(345px, 100%);"></div>
        </div>
      </div>
    </div>
  </div>
</div>
<div class="cui-skeleton-rectangle -is--block">
  <div class="cui-skeleton__item" style="width: 100%; height: 196px;"></div>
</div>`
};
